import { lazy } from 'react';

const AccountsRoutes = [
    {
        path: '/lawyers',
        component: lazy(() => import('../../pages/Accounts/Lawyers')),
        meta: {
            action: 'read',
            resource: 'lawyers',
        },
    },
    {
        path: '/profile',
        component: lazy(() => import('../../pages/Accounts/Profile')),
        meta: {
            action: 'read',
            resource: 'profile',
        },
    },
    {
        path: '/outlook_auth/callback',
        component: lazy(() => import('../../pages/Accounts/OutlookCallback')),
        showNavbar: false,
        meta: {
            action: 'read',
            resource: 'profile',
        },
    },
    {
        path: '/view_lawyer/:lawyerId',
        component: lazy(() => import('../../pages/Accounts/LawyerDetail')),
        exact: true,
        meta: {
            navLink: '/lawyers',
            action: 'update',
            resource: 'lawyers',
        },
    },
    {
        path: '/clients',
        component: lazy(() => import('../../pages/Accounts/LrsClients')),
        meta: {
            action: 'read',
            resource: 'lrs_clients',
        },
    },
    {
        path: '/contacts',
        component: lazy(() => import('../../pages/Accounts/LrsContacts')),
        meta: {
            action: 'read',
            resource: 'lrs_contacts',
        },
    },
    {
        path: '/contact/:contactId',
        component: lazy(() => import('../../pages/Accounts/LrsContactDetail')),
        meta: {
            action: 'read',
            resource: 'lrs_contacts',
        },
    },
];

export default AccountsRoutes;
